<template>
  <div class="participant-task-table" ref="participantTable">
    <div class="row table-title" v-if="displayMobileView === false">
      <div class="col-md-9 pl-0 font-bolder">
        Participant Tasks
        <i>(Due and availability date calculations are based on participant’s time zone.)</i>
      </div>
      <div class="col-md-3 align-right p-0" v-if="!showHideCompliance">
        <span class="font-bolder pr-10">{{ participantTaskCompletionPR }}%</span>Complete
      </div>
    </div>
    <div class="row table-title" v-if="displayMobileView === true">
      <div class="col pl-0 font-bolder">
        Participant Tasks
        <i>(Due and availability date calculations are based on participant’s time zone.)</i>
      </div>
      <div class="col align-right p-0" v-if="!showHideCompliance">
        <span class="font-bolder pr-10">{{ participantTaskCompletionPR }}%</span>Complete
      </div>
    </div>
    <div class="divTable unstyledTable" v-if="displayMobileView === false">
      <div class="divTableHeading">
        <div class="divTableRow">
          <div class="divTableHead" :class="field.class" v-for="(field, index) in participantFields" :key="index">
            <b class="mr-5">{{ field.label }}</b>
            <span class="sortDown mr-2" @click="sortField(field, 'asc')" :class="{ 'disable-icon': !field.ascOrder }"><i class="fa fa-long-arrow-down" aria-hidden="true"></i></span>
            <span class="sortUp" @click="sortField(field, 'desc')" :class="{ 'disable-icon': !field.dscOrder }"><i class="fa fa-long-arrow-up" aria-hidden="true"></i></span>
          </div>
        </div>
      </div>
      <div class="divTableBody" :class="{ 'loading-opacity': apiIsInProgress }" v-if="participantRecords && participantRecords.length > 0">
        <div class="divTableRow" v-for="(record, index) in tasksArrOne" :key="index">
          <div class="divTableCell">
            <span v-if="isStatusEnabled(record.status)" class="status" :class="record.status.toLowerCase()">{{ record.status }}</span>
            <div class="title-icons-container">
              <span
                :title="record.name"
                class="text-info"
                @click="onActivityClick(record)"
                :class="{
                  'pl-85': !isStatusEnabled(record.status),
                  'text-info-cursor': record.status == 'Scheduled' || record.status == 'Missed' || record.status == 'Current' || record.status == 'Removed',
                  'blinded-site': isUserBlinded,
                  'removed-text-info': record.status == 'Removed'
                }"
                >{{ truncate(record) }}</span
              >
              <div class="icons-container" :class="{ 'pl-85': !isStatusEnabled(record.status) }">
                <span class="mr-5" v-if="record.visitType != null && record.visitType.toLowerCase() === 'phonecall'" @click="showPhoneVisitDetails(record)">
                  <img class="quick-view-icon" src="static/img/telehealth/phonecallLogo.svg" />
                </span>
                <span class="mr-5" v-if="record.visitType != null && record.visitType.toLowerCase() === 'homevisit'" @click="showPhoneVisitDetails(record)">
                  <img class="quick-view-icon" src="static/img/telehealth/homeVisitLogo.svg" />
                </span>

                <span class="mr-5" v-if="checkViewPermissions(record) == false"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
                <span v-else>
                  <span class="mr-5 " v-if="record.status.toLowerCase() == 'complete' && record.visitType != 'In-person' && record.visitType != 'Telehealth' && record.visitType != 'Phonecall' && record.visitType != 'Homevisit'" @click="showActivityResponseModal(record)" :class="{ 'blinded-site': isUserBlinded }">
                    <img class="quick-view-icon" src="static/img/quick-view.svg" />
                  </span>
                </span>
                <!-- when archive list length is greator then 1 then show popover and allow for site team member only-->
                <span v-if="record.archiveList && record.archiveList.length > 1 && isSiteTeamAccess">
                  <span :id="record.callRecordUniqueId" tabindex="0" class="camera" v-if="record.type == 'Telehealth' && record.archiveList != null">
                    <span
                      class="double-camera"
                      :class="{
                        'double-green': record.callRecordUniqueId == mainActiveArchiveId
                      }"
                      >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                    >
                  </span>
                  <b-popover :ref="'element' + record.callRecordUniqueId" v-if="record.callRecordUniqueId" :target="record.callRecordUniqueId" triggers="click blur">
                    <template v-slot:content>
                      <div @click="openRecording(record, archive, 'element' + record.callRecordUniqueId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                        <div class="open-recording mr-10">
                          {{ new Date(archive.startTime) | formatUTCDate }}
                        </div>
                        <span
                          class="blue-camera"
                          :class="{
                            'single-green': archive.id == activeArchiveId
                          }"
                        ></span>
                      </div>
                    </template>
                  </b-popover>
                </span>
                <span v-else>
                  <span v-if="record.archiveList && record.archiveList.length == 1 && record.type == 'Telehealth' && isSiteTeamAccess" @click="openRecording(record, record.archiveList[0])" class="camera">
                    <span
                      class="single-camera"
                      :class="{
                        'single-green': record.callRecordUniqueId == mainActiveArchiveId
                      }"
                    ></span>
                  </span>
                </span>
                <span class="mr-5 ondemand-activity-icon" v-if="(record.activitySchedulineMode.toLowerCase() === 'ondemand' || record.activitySchedulineMode.toLowerCase() === 'prescreened') && !canRaterAccess" data-toggle="modal" @click="onDemandModalshow(record)">
                  <img class="quick-view-icon" src="static/img/participant-profile/send_activity_on.svg" />
                </span>
                <span class="mr-5 optional-activity-icon" v-if="record.isActivityOptional">
                  <img class="quick-view-icon" src="static/img/participant-profile/optional_activity.svg" alt v-b-popover.hover="'Activity is optional and will be excluded from the compliance report'" :popover-style="{ background: '#ffffff' }" />
                </span>
                <span v-if="record.missedDueToMSSkip" class="skipped-task" aria-hidden="true" v-b-popover.hover="'Activity has been skipped due to change in study day'" :popover-style="{ background: '#ffffff' }">
                  <img src="static/img/Icon_ Activity_Skipped.png" />
                </span>
              </div>
            </div>
          </div>
          <div class="divTableCell" v-if="isSiteShowInPreScreen">
            <span v-if="record.status.toLowerCase() != 'complete' && record.status.toLowerCase() != 'removed' && triggerForParticipantTask" class="due-date-indicator">{{ new Date(record.dueDate) | dueDateIndicator }}</span>
          </div>
          <div class="divTableCell color-text">
            <div v-if="record.status.toLowerCase() != 'missed' && record.status.toLowerCase() != 'scheduled' && record.status.toLowerCase() != 'removed' && record.status.toLowerCase() != 'cancelled'">
              <span>{{ new Date(record.completedOn) | formatUTCDate }}</span>
              <span class="clock ml-5" :id="record.reportedDataTrackerId" tabindex="0"></span>
              <b-popover :target="record.reportedDataTrackerId" triggers="click blur">
                <template v-slot:content>
                  <div class="popover-content">
                    <span class="person"></span>
                    <div class="ml-15 text-uppercase">
                      {{ dateInReadableFormat(record) }}
                    </div>
                  </div>
                  <div class="popover-content">
                    <span class="clinic"></span>
                    <div class="ml-15 text-uppercase">
                      {{ toPILocalTime(record) }}
                    </div>
                  </div>
                </template>
              </b-popover>
            </div>
          </div>
          <div class="divTableCell color-text" v-if="isSiteShowInPreScreen && record.status.toLowerCase() != 'removed'">
            {{ record.availibilityWindow }}
          </div>
          <div class="divTableCell color-text pl-24" v-if="record.status.toLowerCase() === 'removed'"></div>
          <div class="divTableCell color-text">{{ record.deviceType }}</div>
          <div class="divTableCell w-190 color-text pl-24 status-align">
            <span v-if="record.approveStatus && record.approveStatus.toLowerCase() === 'approved' && record.approvedDate">{{ new Date(record.approvedDate) | formatUTCDate }}</span>
          </div>
          <div class="divTableCell w-190 color-text pl-24 status-align">
            <span v-if="record.verificationStatus && record.verificationStatus.toLowerCase() === 'verified' && record.verifiedDate">{{ new Date(record.verifiedDate) | formatUTCDate }}</span>
          </div>
          <div class="divTableCell w-190 color-text pl-24 status-align">
            <span v-if="record.signoffStatus && record.signoffStatus.toLowerCase() === 'signedoff' && record.signoffDate">{{ new Date(record.signoffDate) | formatUTCDate }}</span>
          </div>
          <div class="divTableCell w-190 color-text pl-24 status-align">
            <span v-if="record.reviewStatus && record.reviewStatus.toLowerCase() === 'reviewed' && record.reviewedDate">{{ new Date(record.reviewedDate) | formatUTCDate }}</span>
          </div>
          <div class="divTableCell w-190 color-text pl-24 status-align">
            <span v-if="record.lockStatus && record.lockStatus.toLowerCase() === 'locked' && record.lockedDate">{{ new Date(record.lockedDate) | formatUTCDate }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="displayMobileView === true">
      <div :class="{ 'loading-opacity': apiIsInProgress }" v-if="participantRecords && participantRecords.length > 0">
        <div class="card shadow rounded my-2" v-for="(record, index) in tasksArrOne" :key="index">
          <div class="py-2">
            <span v-if="isStatusEnabled(record.status)" class="status" :class="record.status.toLowerCase()">{{ record.status }}</span>
            <span
              :title="record.name"
              class="text-info"
              @click="onActivityClick(record)"
              :class="{
                'pl-85': !isStatusEnabled(record.status),
                'text-info-cursor': record.status == 'Scheduled' || record.status == 'Missed' || record.status == 'Current' || record.status == 'Removed',
                'blinded-site': isUserBlinded,
                'removed-text-info': record.status == 'Removed'
              }"
              >{{ truncate(record) }}</span
            >
            <span class="ml-5 " v-if="record.status.toLowerCase() == 'complete' && record.visitType != 'In-person' && record.visitType != 'Telehealth' && record.visitType != 'Phonecall' && record.visitType != 'Homevisit'" @click="showActivityResponseModal(record)" :class="{ 'blinded-site': isUserBlinded }">
              <span class="ml-5" v-if="checkViewPermissions(record) == false"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
              <img v-else class="quick-view-icon" src="static/img/quick-view.png" />
            </span>
            <!-- when archive list length is greator then 1 then show popover and allow for site team member only-->
            <span v-if="record.archiveList && record.archiveList.length > 1 && isSiteTeamAccess">
              <span :id="record.callRecordUniqueId" tabindex="0" class="camera" v-if="record.type == 'Telehealth' && record.archiveList != null">
                <span
                  class="double-camera"
                  :class="{
                    'double-green': record.callRecordUniqueId == mainActiveArchiveId
                  }"
                  >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                >
              </span>
              <b-popover :ref="'element' + record.callRecordUniqueId" v-if="record.callRecordUniqueId" :target="record.callRecordUniqueId" triggers="click blur">
                <template v-slot:content>
                  <div @click="openRecording(record, archive, 'element' + record.callRecordUniqueId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                    <div class="open-recording mr-10">
                      {{ new Date(archive.startTime) | formatUTCDate }}
                    </div>
                    <span class="blue-camera" :class="{ 'single-green': archive.id == activeArchiveId }"></span>
                  </div>
                </template>
              </b-popover>
            </span>
            <span v-else>
              <span v-if="record.archiveList && record.archiveList.length == 1 && record.type == 'Telehealth' && isSiteTeamAccess" @click="openRecording(record, record.archiveList[0])" class="camera">
                <span
                  class="single-camera"
                  :class="{
                    'single-green': record.callRecordUniqueId == mainActiveArchiveId
                  }"
                ></span>
              </span>
            </span>
            <span class="ml-5 ondemand-activity-icon" v-if="record.activitySchedulineMode.toLowerCase() === 'ondemand'">
              <img src="static/img/participant-profile/send_activity_on.svg" />
            </span>
            <span class="ml-5 optional-activity-icon" v-if="record.isActivityOptional">
              <img src="static/img/participant-profile/optional_activity.svg" alt v-b-popover.hover="'Activity is optional and will be excluded from the compliance report'" :popover-style="{ background: '#ffffff' }" />
            </span>
            <span v-if="record.missedDueToMSSkip" class="skipped-task" aria-hidden="true" v-b-popover.hover="'Activity has been skipped due to change in study day'" :popover-style="{ background: '#ffffff' }">
              <img src="static/img/Icon_ Activity_Skipped.png" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="no-task slide-animation" v-if="enableParticipantTable && participantRecords.length == 0">
      No tasks available
    </div>
    <div class="show_all_div" v-if="enableParticipantTable && participantRecords.length > 0">
      <div
        v-if="!isParticipantTasksSectionExpand && enableParticipantTable && participantRecords.length > 0 && showExpandButton"
        @click="isParticipantTasksSectionExpand = !isParticipantTasksSectionExpand"
        :class="isParticipantTasksSectionExpand ? null : 'collapsed'"
        :aria-expanded="isParticipantTasksSectionExpand"
        v-b-toggle.collapse-participant-tasks
        variant="primary"
        class="toggle-text pt-10 pb-10"
      >
        Show all tasks<span></span>
      </div>
      <b-collapse v-if="enableParticipantTable" v-model="isParticipantTasksSectionExpand" id="collapse-participant-tasks" class="mt-2">
        <b-card v-if="displayMobileView === false">
          <div class="divTable">
            <div class="divTableBody" :class="{ 'loading-opacity': apiIsInProgress }">
              <div class="divTableRow" v-for="(record, index) in tasksArrTwo" :key="index">
                <div class="divTableCell w-300">
                  <span v-if="isStatusEnabled(record.status)" class="status" :class="record.status.toLowerCase()">{{ record.status }}</span>
                  <div class="title-icons-container">
                    <span
                      :title="record.name"
                      class="text-info"
                      @click="onActivityClick(record)"
                      :class="{
                        'pl-85': !isStatusEnabled(record.status),
                        'text-info-cursor': record.status == 'Scheduled' || record.status == 'Missed' || record.status == 'Current' || record.status == 'Removed',
                        'blinded-site': isUserBlinded,
                        'removed-text-info': record.status == 'Removed'
                      }"
                      >{{ truncate(record) }}</span
                    >
                    <div class="icons-container" :class="{ 'pl-85': !isStatusEnabled(record.status) }">
                      <span class="mr-5" v-if="record.visitType != null && record.visitType.toLowerCase() === 'phonecall'" @click="showPhoneVisitDetails(record)">
                        <img class="visitTypeIcon" src="static/img/telehealth/phonecallLogo.svg" />
                      </span>
                      <span class="mr-5" v-if="record.visitType != null && record.visitType.toLowerCase() === 'homevisit'" @click="showPhoneVisitDetails(record)">
                        <img class="visitTypeIcon" src="static/img/telehealth/homeVisitLogo.svg" />
                      </span>
                      <!--  -->
                      <span class="mr-5" v-if="checkViewPermissions(record) == false"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
                      <span v-else>
                        <span class="mr-5 " v-if="record.status.toLowerCase() == 'complete' && record.visitType != 'In-person' && record.visitType != 'Telehealth' && record.visitType != 'Phonecall' && record.visitType != 'Homevisit'" @click="showActivityResponseModal(record)" :class="{ 'blinded-site': isUserBlinded }">
                          <img class="quick-view-icon" src="static/img/quick-view.png" />
                        </span>
                      </span>

                      <!-- when archive list length is freator then 1 then show popover -->
                      <span v-if="record.archiveList && record.archiveList.length > 1 && isSiteTeamAccess">
                        <span :id="record.callRecordUniqueId" tabindex="0" class="camera" v-if="record.type == 'Telehealth' && record.archiveList != null">
                          <span
                            class="double-camera"
                            :class="{
                              'double-green': record.callRecordUniqueId == mainActiveArchiveId
                            }"
                            >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                          >
                        </span>
                        <b-popover :ref="'element' + record.callRecordUniqueId" v-if="record.callRecordUniqueId" :target="record.callRecordUniqueId" triggers="click blur">
                          <template v-slot:content>
                            <div @click="openRecording(record, archive, 'element' + record.callRecordUniqueId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                              <div class="open-recording mr-10">
                                {{ new Date(archive.startTime) | formatUTCDate }}
                              </div>
                              <span
                                class="blue-camera"
                                :class="{
                                  'single-green': archive.id == activeArchiveId
                                }"
                              ></span>
                            </div>
                          </template>
                        </b-popover>
                      </span>
                      <!-- else show simple form of camera -->
                      <span v-else>
                        <span v-if="record.archiveList && record.archiveList.length == 1 && record.type == 'Telehealth' && isSiteTeamAccess" @click="openRecording(record, record.archiveList[0])" class="camera">
                          <span
                            class="single-camera"
                            :class="{
                              'single-green': record.callRecordUniqueId == mainActiveArchiveId
                            }"
                          ></span>
                        </span>
                      </span>
                      <span class="mr-5 ondemand-activity-icon" v-if="record.activitySchedulineMode.toLowerCase() === 'ondemand'" data-toggle="modal" @click="onDemandModalshow(record)">
                        <img src="static/img/participant-profile/send_activity_on.svg" />
                      </span>
                      <span class="mr-5 optional-activity-icon" v-if="record.isActivityOptional">
                        <img src="static/img/participant-profile/optional_activity.svg" alt v-b-popover.hover="'Activity is optional and will be excluded from the compliance report'" :popover-style="{ background: '#ffffff' }" />
                      </span>
                      <span v-if="record.missedDueToMSSkip" class="skipped-task" aria-hidden="true" v-b-popover.hover="'Activity has been skipped due to change in study day'" :popover-style="{ background: '#ffffff' }">
                        <img src="static/img/Icon_ Activity_Skipped.png" />
                      </span>
                    </div>
                  </div>
                </div>
                <div class="divTableCell w-120" v-if="isSiteShowInPreScreen">
                  <span v-if="record.status.toLowerCase() != 'complete' && record.status.toLowerCase() != 'removed' && triggerForParticipantTask" class="due-date-indicator">{{ new Date(record.dueDate) | dueDateIndicator }}</span>
                </div>
                <div class="divTableCell color-text w-250">
                  <div v-if="record.status.toLowerCase() != 'missed' && record.status.toLowerCase() != 'scheduled' && record.status.toLowerCase() != 'removed' && record.status.toLowerCase() != 'cancelled'">
                    <span>{{ new Date(record.completedOn) | formatUTCDate }}</span>
                    <span class="clock ml-5" :id="record.reportedDataTrackerId" tabindex="0"></span>
                    <b-popover :target="record.reportedDataTrackerId" triggers="click blur">
                      <template v-slot:content>
                        <div class="popover-content">
                          <span class="person"></span>
                          <div class="ml-15 text-uppercase">
                            {{ dateInReadableFormat(record) }}
                          </div>
                        </div>
                        <div class="popover-content">
                          <span class="clinic"></span>
                          <div class="ml-15 text-uppercase">
                            {{ toPILocalTime(record) }}
                          </div>
                        </div>
                      </template>
                    </b-popover>
                  </div>
                </div>
                <div class="divTableCell w-150 color-text" v-if="isSiteShowInPreScreen && record.status.toLowerCase() != 'removed'">
                  {{ record.availibilityWindow }}
                </div>
                <div class="divTableCell color-text" v-if="record.status.toLowerCase() === 'removed'"></div>
                <div class="divTableCell w-124 color-text pl-24">
                  {{ record.deviceType }}
                </div>
                <div class="divTableCell w-190 color-text pl-24 status-align">
                  <span v-if="record.approveStatus && record.approveStatus.toLowerCase() === 'approved' && record.approvedDate">{{ new Date(record.approvedDate) | formatUTCDate }}</span>
                </div>
                <div class="divTableCell w-190 color-text pl-32 status-align">
                  <span v-if="record.verificationStatus && record.verificationStatus.toLowerCase() === 'verified' && record.verifiedDate">{{ new Date(record.verifiedDate) | formatUTCDate }}</span>
                </div>
                <div class="divTableCell w-190 color-text pl-32 status-align">
                  <span v-if="record.signoffStatus && record.signoffStatus.toLowerCase() === 'signedoff' && record.signoffDate">{{ new Date(record.signoffDate) | formatUTCDate }}</span>
                </div>
                <div class="divTableCell w-190 color-text pl-32 status-align">
                  <span v-if="record.reviewStatus && record.reviewStatus.toLowerCase() === 'reviewed' && record.reviewedDate">{{ new Date(record.reviewedDate) | formatUTCDate }}</span>
                </div>
                <div class="divTableCell w-190 color-text pl-32 status-align">
                  <span v-if="record.lockStatus && record.lockStatus.toLowerCase() === 'locked' && record.lockedDate">{{ new Date(record.lockedDate) | formatUTCDate }}</span>
                </div>
              </div>
            </div>
          </div>
          <nav aria-label="page navigation pagination" v-if="isPaginationEnabled">
            <ul class="pagination">
              <li class="page-item">
                <a
                  @click="loadRecords($event, 'previous')"
                  :class="{
                    disabled: apiIsInProgress || this.localPaginationObject.currentPage == 1
                  }"
                  class="page-link arrow"
                  href="#"
                  >&#706;</a
                >
              </li>
              <li class="page-item">
                <a class="page-link">{{ this.localPaginationObject.currentPage }}</a>
              </li>
              <li class="page-item pt-1">
                <span class="of">of</span><span class="mr-3 ttlPge pt-0">{{ this.localPaginationObject.totalPage }}</span>
              </li>
              <li class="page-item">
                <a
                  @click="loadRecords($event, 'next')"
                  :class="{
                    disabled: apiIsInProgress || this.localPaginationObject.currentPage == this.localPaginationObject.totalPage
                  }"
                  class="page-link arrow"
                  href="#"
                  >></a
                >
              </li>
            </ul>
          </nav>
        </b-card>

        <div v-if="displayMobileView === true">
          <div :class="{ 'loading-opacity': apiIsInProgress }">
            <div class="card shadow rounded my-2" v-for="(record, index) in tasksArrTwo" :key="index">
              <div class="py-2">
                <span v-if="isStatusEnabled(record.status)" class="status" :class="record.status.toLowerCase()">{{ record.status }}</span>
                <span
                  :title="record.name"
                  class="text-info"
                  @click="onActivityClick(record)"
                  :class="{
                    'pl-85': !isStatusEnabled(record.status),
                    'text-info-cursor': record.status == 'Scheduled' || record.status == 'Missed' || record.status == 'Current' || record.status == 'Removed',
                    'blinded-site': isUserBlinded,
                    'removed-text-info': record.status == 'Removed'
                  }"
                  >{{ truncate(record) }}</span
                >
                <span class="ml-5 " v-if="record.status.toLowerCase() == 'complete' && record.visitType != 'In-person' && record.visitType != 'Telehealth' && record.visitType != 'Phonecall' && record.visitType != 'Homevisit'" @click="showActivityResponseModal(record)" :class="{ 'blinded-site': isUserBlinded }">
                  <span class="ml-5" v-if="checkViewPermissions(record) == false"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
                  <img v-else class="quick-view-icon" src="static/img/quick-view.png" />
                </span>
                <!-- when archive list length is freator then 1 then show popover -->
                <span v-if="record.archiveList && record.archiveList.length > 1 && isSiteTeamAccess">
                  <span :id="record.callRecordUniqueId" tabindex="0" class="camera" v-if="record.type == 'Telehealth' && record.archiveList != null">
                    <span
                      class="double-camera"
                      :class="{
                        'double-green': record.callRecordUniqueId == mainActiveArchiveId
                      }"
                      >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                    >
                  </span>
                  <b-popover :ref="'element' + record.callRecordUniqueId" v-if="record.callRecordUniqueId" :target="record.callRecordUniqueId" triggers="click blur">
                    <template v-slot:content>
                      <div @click="openRecording(record, archive, 'element' + record.callRecordUniqueId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                        <div class="open-recording mr-10">
                          {{ new Date(archive.startTime) | formatUTCDate }}
                        </div>
                        <span
                          class="blue-camera"
                          :class="{
                            'single-green': archive.id == activeArchiveId
                          }"
                        ></span>
                      </div>
                    </template>
                  </b-popover>
                </span>
                <!-- else show simple form of camera -->
                <span v-else>
                  <span v-if="record.archiveList && record.archiveList.length == 1 && record.type == 'Telehealth' && isSiteTeamAccess" @click="openRecording(record, record.archiveList[0])" class="camera">
                    <span
                      class="single-camera"
                      :class="{
                        'single-green': record.callRecordUniqueId == mainActiveArchiveId
                      }"
                    ></span>
                  </span>
                </span>
                <span class="ml-5 ondemand-activity-icon" v-if="record.activitySchedulineMode.toLowerCase() === 'ondemand'">
                  <img src="static/img/participant-profile/send_activity_on.svg" />
                </span>
                <span class="ml-5 optional-activity-icon" v-if="record.isActivityOptional">
                  <img src="static/img/participant-profile/optional_activity.svg" alt v-b-popover.hover="'Activity is optional and will be excluded from the compliance report'" :popover-style="{ background: '#ffffff' }" />
                </span>
                <span v-if="record.missedDueToMSSkip" class="skipped-task" aria-hidden="true" v-b-popover.hover="'Activity has been skipped due to change in study day'" :popover-style="{ background: '#ffffff' }">
                  <img src="static/img/Icon_ Activity_Skipped.png" />
                </span>
              </div>
            </div>
          </div>
          <nav aria-label="page navigation pagination" v-if="isPaginationEnabled">
            <ul class="pagination hello">
              <li class="page-item">
                <a
                  @click="loadRecords($event, 'previous')"
                  :class="{
                    disabled: apiIsInProgress || this.localPaginationObject.currentPage == 1
                  }"
                  class="page-link arrow"
                  href="#"
                  >&#706;</a
                >
              </li>
              <li class="page-item">
                <a class="page-link">{{ this.localPaginationObject.currentPage }}</a>
              </li>
              <li class="page-item pt-1">
                <span class="of">of</span><span class="mr-3 ttlPge pt-0">{{ this.localPaginationObject.totalPage }}</span>
              </li>
              <li class="page-item">
                <a
                  @click="loadRecords($event, 'next')"
                  :class="{
                    disabled: apiIsInProgress || this.localPaginationObject.currentPage == this.localPaginationObject.totalPage
                  }"
                  class="page-link arrow"
                  href="#"
                  >></a
                >
              </li>
            </ul>
          </nav>
        </div>
        <div v-if="!isPaginationEnabled && showCollapseButton" @click="isParticipantTasksSectionExpand = !isParticipantTasksSectionExpand" v-b-toggle.collapse-participant-tasks variant="primary" class="toggle-text pb-10 pt-15">Collapse tasks<span class="collapsed"></span></div>
      </b-collapse>
    </div>
    <!-- Participant Submitted response modal -->
    <ParticipantResponseModal v-show="responseActivityDetail !== null" ref="activityResponseModal" :responseActivityDetail="responseActivityDetail" :responseLanguageOptions="responseLanguageOptions" :generalParticipantInfo="generalParticipantInfo" :showTotalScore="showTotalScore" @resetActivityResponse="responseActivityDetail = null" />
    <b-modal ref="HomePhonecallDataViewModal" id="home-phonecall-data-view-modal" no-close-on-backdrop hide-footer hide-header body-class="modal-body-custom pt-0">
      <div>
        <img class="close-icon" src="static/img/close-new.svg" @click="$refs.HomePhonecallDataViewModal.hide()" />
      </div>
      <div class="activityNameLayout">
        <b
          ><p class="fs-16 pl-10 pr-10">{{ visitTypeDetails.visitName }}<br /></p
        ></b>
      </div>
      <div class="clearfix"></div>
      <div>
        <b-row class="rowDiv pt-10 pb-10">
          <b-col cols="4">
            <div class="subHeading pb-5">Participant ID</div>
            <div style="word-break:break-all;">
              {{ visitTypeDetails.participantId }}
            </div>
          </b-col>
          <b-col cols="8">
            <div class="subHeading pb-5">THREAD ID</div>
            <div>{{ visitTypeDetails.threadId }}</div>
          </b-col>
        </b-row>
      </div>
      <div v-if="visitTypeDetails.visitType === 'homevisit'">
        <div class="mt-20">
          <span class="evaluateAddressField">Visit Address </span>
        </div>
        <div class="w-200">
          <span class="evaluateModalPhnoField">
            {{ showVisitAddress(visitTypeDetails.details) }}
          </span>
        </div>
      </div>
      <div v-if="visitTypeDetails.visitType === 'phonecall'">
        <div class="mt-20">
          <span class="evaluateAddressField">Phone Number</span>
        </div>
        <div class="w-200">
          <span class="evaluateModalPhnoField">
            <span v-if="visitTypeDetails.details.countryCode != null">{{ visitTypeDetails.details.countryCode }} </span>
            <span v-if="visitTypeDetails.details.phoneNumber != null">{{ visitTypeDetails.details.phoneNumber }}</span>
          </span>
        </div>
      </div>
    </b-modal>
    <ScheduleVisitSiteTeam v-if="showScheduleVisit === true" modalType="postScheduleVisit" @scheduledVisitData="getConfiguredVisitData" @cancelEvent="cancelModal()" />

    <b-modal ref="cancleOnDemondModal" size="xl" hide-footer body-class="my-modal">
      <div class="modal-header">
        <div class="cancle-activity-title">{{ copyRecord.name }}</div>
      </div>
      <div v-if="copyRecord.status === 'Scheduled'">
        <button class="margin-for-cancle-btn activity-cancel-btn" data-toggle="modal" @click="cancleOnDemoanActivity()">
          Cancel
        </button>
      </div>
      <div class="table-responsive">
        <table class="table table-borderless">
          <thead>
            <tr>
              <th class="heading-title">DATE/TIME SENT</th>
              <th class="heading-title">USER SENT</th>
              <th class="heading-title">DATE/TIME CANCELLED</th>
              <th class="heading-title">USER CANCELLED</th>
              <th class="heading-title">REASON FOR CANCELLATION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(field, index) in onDemandActivityDetails" :key="index">
              <td>{{ field.sentDate | formatUTCDate }}</td>
              <td>{{ field.sentBy }}</td>
              <td>
                <span v-if="field.withdrawnDateUtc">{{ field.withdrawnDateUtc | formatUTCDate }}</span>
              </td>
              <td>{{ field.withdrawnBy }}</td>
              <td>{{ field.withdrawnReason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal ref="addCancleReason" hide-footer>
      <div class="modal-header">
        <div class="cancle-activity-name">Cancel Activity</div>
      </div>
      <div class="text-message">
        Are you sure you want to cancel? Canceling an activity will remove it from the participant’s study app. This action cannot be undone.
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <label class="reason-label">Reason for cancellation <span class="optional">(optional)</span></label>
          <input class="withdrawn-reason" type="text" v-model="withdrawnReason" name="withdrawnReason" />
          <div class="row">
            <button type="button" class="btn btn-no" @click="cancleActivityModal()">
              No
            </button>
            <button type="button" class="btn btn-yes" @click="deleteOnDemondActivity()">
              Yes
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ParticipantResponseModal from "@/components/participants/activity-response-modal";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import { AclRule } from "vue-acl";
import _ from "lodash";
import { mapGetters } from "vuex";
import { PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, RATER, INTERVIEWER, CC, SUPPORT } from "@/constants/authRoles";
import * as constant from "../../constants/config";
import ScheduleVisitSiteTeam from "../participants/telehealth/schedule-visit-siteteam.vue";
import toastr from "toastr";
import localStorageService from "@/services/localStorage";

export default {
  name: "participant-tasks-table",
  components: {
    ParticipantResponseModal,
    ScheduleVisitSiteTeam
  },
  props: {
    participantTaskRecords: {
      type: Array
    },
    participantInfo: {
      type: Object
    },
    generalParticipantInfo: {
      type: Object
    },
    enableParticipantTable: {
      type: Boolean
    },
    participantTaskCompletionPR: {
      type: Number
    },
    participantPaginationObject: {
      type: Object
    },
    showAllParticipantTasks: {
      type: Boolean,
      default: false
    },
    participantTableDataLoading: {
      type: Boolean,
      default: false
    },
    participantTaskSectionEnabled: {
      type: Boolean
    },
    triggerForParticipantTask: {
      type: Boolean
    },
    isDetailedActivityPageAccessable: {
      type: Boolean
    },
    showHideCompliance: {
      type: Boolean
    },
    isSiteShowInPreScreen: {
      type: Boolean
    },
    studyResponse: {
      type: Object
    }
  },
  data() {
    return {
      participantFields: [
        {
          key: "name",
          type: "string",
          label: "Name",
          ascOrder: false,
          dscOrder: false,
          class: "w-300 pl-85",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "dueDate",
          type: "integer",
          label: "Due",
          ascOrder: false,
          dscOrder: false,
          class: "w-120",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "completedOn",
          type: "integer",
          label: "Completed",
          ascOrder: false,
          dscOrder: false,
          class: "w-250",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "availibilityWindow",
          type: "string",
          label: "Availability Window",
          ascOrder: false,
          dscOrder: false,
          class: "w-150",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "deviceType",
          type: "string",
          label: "Device Type",
          ascOrder: false,
          dscOrder: false,
          class: "w-124 pl-24",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "approveStatus",
          type: "integer",
          label: "Approved",
          ascOrder: false,
          dscOrder: false,
          class: "w-104 pl-24",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "verificationStatus",
          type: "integer",
          label: "Verified",
          ascOrder: false,
          dscOrder: false,
          class: "w-100 pl-32",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "signoffStatus",
          type: "integer",
          label: "Signed off",
          ascOrder: false,
          dscOrder: false,
          class: "w-115 pl-32",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "reviewStatus",
          type: "integer",
          label: "Reviewed",
          ascOrder: false,
          dscOrder: false,
          class: "w-115 pl-32",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "lockStatus",
          type: "integer",
          label: "Locked",
          ascOrder: false,
          dscOrder: false,
          class: "w-100 pl-32",
          currentOrder: null,
          ableToSort: true
        }
      ],
      isParticipantTasksSectionExpand: false,
      participantRecords: [],
      responseLanguageOptions: [],
      responseActivityDetail: null,
      localPaginationObject: {},
      isPaginationEnabled: false,
      apiIsInProgress: false,
      showCollapseButton: false,
      showExpandButton: false,
      activeArchiveId: null,
      mainActiveArchiveId: null,
      displayMobileView: Boolean,
      noCloseOnOutsideClick: true,
      visitTypeDetails: {},
      showScheduleVisit: false,
      showTotalScore: false,
      onDemandActivityDetails: [],
      taskInstanceId: "",
      studyVersionId: "",
      copyRecord: {},
      withdrawnReason: ""
    };
  },
  created() {
    if (constant.SCREENWIDTH > 767) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  computed: {
    ...mapGetters(["token", "user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    tasksArrOne() {
      return this.participantRecords.slice(0, 5);
    },
    tasksArrTwo() {
      return this.participantRecords.slice(5, this.participantRecords.length);
    },
    isUserBlinded() {
      if (this.user.userSite && this.user.siteIds) {
        const isBlinded = this.user.userSite.filter(item => item.siteId == this.user.siteIds[0]);
        return isBlinded[0].blinded;
      } else if (this.user.userStudies && this.user.siteIds) {
        const isBlinded = this.user.userStudies.filter(item => item.siteId == this.user.siteIds[0]);
        return isBlinded[0].blinded;
      } else {
        return false;
      }
    },
    isSiteTeamAccess() {
      return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.canCallCenterAccess || this.canInterviewerAccess || this.canRaterAccess;
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    }
  },
  watch: {
    isSiteShowInPreScreen: {
      handler(val) {
        if (val) {
          this.participantFields = [
            {
              key: "name",
              type: "string",
              label: "Name",
              ascOrder: false,
              dscOrder: false,
              class: "w-300 pl-85",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "dueDate",
              type: "integer",
              label: "Due",
              ascOrder: false,
              dscOrder: false,
              class: "w-120",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "completedOn",
              type: "integer",
              label: "Completed",
              ascOrder: false,
              dscOrder: false,
              class: "w-250",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "availibilityWindow",
              type: "string",
              label: "Availability Window",
              ascOrder: false,
              dscOrder: false,
              class: "w-155",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "deviceType",
              type: "string",
              label: "Device Type",
              ascOrder: false,
              dscOrder: false,
              class: "w-124 pl-24",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "approveStatus",
              type: "integer",
              label: "Approved",
              ascOrder: false,
              dscOrder: false,
              class: "w-104 pl-24",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "verificationStatus",
              type: "integer",
              label: "Verified",
              ascOrder: false,
              dscOrder: false,
              class: "w-100 pl-32",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "signoffStatus",
              type: "integer",
              label: "Signed off",
              ascOrder: false,
              dscOrder: false,
              class: "w-115 pl-32",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "reviewStatus",
              type: "integer",
              label: "Reviewed",
              ascOrder: false,
              dscOrder: false,
              class: "w-115 pl-32",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "lockStatus",
              type: "integer",
              label: "Locked",
              ascOrder: false,
              dscOrder: false,
              class: "w-100 pl-32",
              currentOrder: null,
              ableToSort: true
            }
          ];
        } else {
          this.participantFields = [
            {
              key: "name",
              type: "string",
              label: "Name",
              ascOrder: false,
              dscOrder: false,
              class: "w-300 pl-85",
              currentOrder: null,
              ableToSort: true
            },
            //{key: "dueDate", type: "integer", label: "Due", ascOrder: false, dscOrder: false, class: 'w-120', currentOrder: null, ableToSort: true},
            {
              key: "completedOn",
              type: "integer",
              label: "Completed",
              ascOrder: false,
              dscOrder: false,
              class: "w-250",
              currentOrder: null,
              ableToSort: true
            },
            //{key: "availibilityWindow", type: "string", label: "Availability Window", ascOrder: false, dscOrder: false, class: 'w-155', currentOrder: null, ableToSort: true},
            {
              key: "deviceType",
              type: "string",
              label: "Device Type",
              ascOrder: false,
              dscOrder: false,
              class: "w-124 pl-24",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "approveStatus",
              type: "integer",
              label: "Approved",
              ascOrder: false,
              dscOrder: false,
              class: "w-104 pl-24",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "verificationStatus",
              type: "integer",
              label: "Verified",
              ascOrder: false,
              dscOrder: false,
              class: "w-100 pl-32",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "signoffStatus",
              type: "integer",
              label: "Signed off",
              ascOrder: false,
              dscOrder: false,
              class: "w-115 pl-32",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "reviewStatus",
              type: "integer",
              label: "Reviewed",
              ascOrder: false,
              dscOrder: false,
              class: "w-115 pl-32",
              currentOrder: null,
              ableToSort: true
            },
            {
              key: "lockStatus",
              type: "integer",
              label: "Locked",
              ascOrder: false,
              dscOrder: false,
              class: "w-100 pl-32",
              currentOrder: null,
              ableToSort: true
            }
          ];
        }
      }
    },
    participantTableDataLoading: {
      handler(val) {
        if (val) {
          this.apiIsInProgress = true;
        }
      }
    },
    participantTaskRecords: {
      handler() {
        if (this.showAllParticipantTasks) {
          this.isParticipantTasksSectionExpand = true;
        } else {
          this.isParticipantTasksSectionExpand = false;
        }
        this.participantRecords = _.cloneDeep(this.participantTaskRecords);
        // disabled sorting if scheduled / due task is not there
        const disabledSortingForCompletedColumn = this.participantRecords.filter(f => {
          return f.status.toLowerCase() == "complete";
        });
        const disabledSortingForDueColumn = this.participantRecords.filter(f => {
          return f.status.toLowerCase() !== "complete";
        });
        const disabledSortingForDeviceType = this.participantRecords.filter(f => {
          return f.deviceType != "";
        });
        const disabledSortingForApproved = this.participantRecords.filter(f => {
          return f.approveStatus == "APPROVED";
        });
        const disabledSortingForVerified = this.participantRecords.filter(f => {
          return f.verificationStatus == "VERIFIED";
        });
        const disabledSortingForReviewed = this.participantRecords.filter(f => {
          return f.reviewStatus == "REVIEWED";
        });
        const disabledSortingForSignedOff = this.participantRecords.filter(f => {
          return f.signoffStatus == "SIGNED OFF";
        });
        const disabledSortingForLocked = this.participantRecords.filter(f => {
          return f.lockStatus == "LOCKED";
        });
        this.participantFields.map(field => {
          if (field.key == "dueDate") {
            field.ableToSort = disabledSortingForDueColumn.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "completedOn") {
            field.ableToSort = disabledSortingForCompletedColumn.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "deviceType") {
            field.ableToSort = disabledSortingForDeviceType.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "approveStatus") {
            field.ableToSort = disabledSortingForApproved.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "verificationStatus") {
            field.ableToSort = disabledSortingForVerified.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "reviewStatus") {
            field.ableToSort = disabledSortingForReviewed.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "signoffStatus") {
            field.ableToSort = disabledSortingForSignedOff.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "lockStatus") {
            field.ableToSort = disabledSortingForLocked.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
        });
      }
    },
    participantPaginationObject: {
      handler(val) {
        this.apiIsInProgress = false;
        if ((val.totalPage == 1 || val.totalPage == 0) && val.totalRecords <= 5) {
          this.isPaginationEnabled = false;
          this.showCollapseButton = false;
          this.showExpandButton = false;
          return;
        } else if ((val.totalPage == 1 || val.totalPage == 0) && val.totalRecords > 5) {
          this.isPaginationEnabled = false;
          this.showCollapseButton = true;
          this.showExpandButton = true;
          return;
        } else if (val.totalPage > 1) {
          this.isPaginationEnabled = true;
          this.showCollapseButton = false;
          this.showExpandButton = true;
        }
        this.preparePaginationObject();
      }
    }
  },
  methods: {
    onActivityClick(activity) {
      if (this.checkViewPermissions(activity) == false) {
        return;
      }

      const activityStatus = activity.status && activity.status.toLowerCase();
      const activityType = activity.type && activity.type.toLowerCase();
      const activityName = activity.name && activity.name.toLowerCase();

      if (activityStatus === "complete" && (activityType === "survey" || activityType === "epro" || activityType === "activity")) {
        // this.$emit('displayActivityDetailView', activity);

        const { studyId, participantId, id, completedOn, reportedDataTrackerId, type, name } = activity;
        if (activityType === "epro" || activityType === "survey" || (activityType === "activity" && this.checkEdroActivity(activityName))) {
          this.$router.push({
            name: "study-participant-activity-response-edit",
            query: { activityId: id, completedOn, reportedDataTrackerId, type },
            params: { studyId, participantId, name }
          });
        }
      }
    },
    preparePaginationObject() {
      this.localPaginationObject = _.cloneDeep(this.participantPaginationObject);
    },
    loadRecords(event, direction) {
      event.preventDefault();
      if (this.apiIsInProgress) {
        return;
      }
      if (direction == "next") {
        if (this.localPaginationObject.currentPage == this.localPaginationObject.totalPage) {
          return;
        } else {
          this.apiIsInProgress = true;
          const currentPage = this.localPaginationObject.currentPage + 1;
          const obj = {
            pageIndex: currentPage,
            pageSize: 10,
            totalRecords: this.localPaginationObject.totalRecords,
            totalPage: this.localPaginationObject.totalPage
          };
          this.$emit("getNextParticipantRecords", obj);
        }
      } else if (direction == "previous") {
        if (this.localPaginationObject.currentPage == 1) {
          return;
        } else {
          this.apiIsInProgress = true;
          const currentPage = this.localPaginationObject.currentPage - 1;
          const obj = {
            pageIndex: currentPage,
            pageSize: 10,
            totalRecords: this.localPaginationObject.totalRecords,
            totalPage: this.localPaginationObject.totalPage
          };
          this.$emit("getNextParticipantRecords", obj);
        }
      }
    },
    sortField(field, direction) {
      if (!field.ableToSort || this.participantRecords.length == 0) {
        return;
      }
      if (direction == "asc") {
        field.ascOrder = true;
        field.dscOrder = false;
      } else if (direction == "desc") {
        field.ascOrder = false;
        field.dscOrder = true;
      }
      if (field.type == "string") {
        if (field.currentOrder != direction) {
          field.currentOrder = direction;
          this.sortString(direction, field);
        }
      } else if (field.type == "integer" && field.currentOrder != direction) {
        field.currentOrder = direction;
        this.sortTimeStamp(direction, field);
      }
    },
    sortString(direction, field) {
      let records = _.cloneDeep(this.participantTaskRecords);
      records = _.orderBy(records, [records => records[field.key] != undefined && records[field.key].toLowerCase()], direction);
      this.participantRecords = records;
    },
    sortTimeStamp(direction, field) {
      let records = _.cloneDeep(this.participantTaskRecords);
      records = _.orderBy(records, [records => records[field.key] != undefined && records[field.key]], direction);
      this.participantRecords = records;
    },
    truncate(record) {
      const len = record.type == "Telehealth" && record.archiveList == null ? 21 : 15;
      let string = null;
      if (record.name.length > len) {
        string = _.cloneDeep(record.name);
        return string.substring(0, len) + "...";
      }
      return string == null ? record.name : string;
    },
    isStatusEnabled(status) {
      return status.toLowerCase() != "current" && status.toLowerCase() != "scheduled" && status.toLowerCase() != "notstarted" && status.toLowerCase() != "rescheduled";
    },
    showActivityResponseModal(activityDetail) {
      if (activityDetail.status.toLowerCase() == "current" || activityDetail.status.toLowerCase() == "missed" || activityDetail.status.toLowerCase() == "scheduled") {
        return;
      }
      if (activityDetail.type == "Telehealth") {
        return;
      }
      if (!this.isDetailedActivityPageAccessable) {
        this.$toastr.error("Access is denied");
        return;
      }
      this.responseLanguageOptions = [];
      this.responseLanguageOptions.push({ value: "EN", text: "English" });
      //The below code is to find the participant language other than english and push in the responseLanguageOptions options
      if (this.participantInfo && this.participantInfo.participantLanguage) {
        const participantLang = this.participantInfo.participantLanguage.name;
        if (participantLang.toLowerCase() != "english") {
          this.responseLanguageOptions.push({
            value: this.participantInfo.participantLanguage.language_culture,
            text: participantLang,
            languageId: this.participantInfo.participantLanguage.language_id
          });
        }
      }
      this.responseActivityDetail = activityDetail;
      this.$refs.activityResponseModal.show();
    },
    toPILocalTime(record) {
      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      const piLocalTime = momentTimeZone(record.completedOn)
        .tz(abbr)
        .format("DD MMM YYYY hh:mm A z");
      if (piLocalTime.length > 21) {
        return piLocalTime;
      }
      return piLocalTime + abbr;
    },
    dateInReadableFormat(record) {
      const d = moment(record.localCompletedTime).utcOffset(record.localOffset);
      return moment(d).format("DD MMM YYYY hh:mm A");
    },
    openRecording(record, archive, element = null, index = null) {
      if (this.$root.recordingPage.pageName != null && this.$root.recordingPage.pageName != "participantTaskTable") {
        this.$toastr.error("Another recording is currently playing.");
        return;
      }
      if (this.mainActiveArchiveId && this.mainActiveArchiveId != record.callRecordUniqueId) {
        this.$toastr.error("Another recording is currently playing.");
        return;
      }
      if (this.$root.telehealthStarted) {
        this.$toastr.error("Call is in progress. Please try later.");
        return;
      }
      this.$root.recordingPage = { pageName: "participantTaskTable" };
      this.activeArchiveId = archive && archive.id;
      this.mainActiveArchiveId = record.callRecordUniqueId;
      this.getArchiveDetails(archive, record, element, index);
    },
    getArchiveDetails(archive, record, element, index) {
      this.$api.getArchiveUrl(this.$route.params.studyId, archive.archiveId).then(response => {
        if (response.body) {
          const obj = {
            archiveListLength: record.archiveList.length,
            type: "fullScreen",
            archiveUrl: response.body,
            archiveId: archive.archiveId,
            telehealthName: record.name,
            recordDate: archive.startTime,
            archiveList: record.archiveList.length > 1 ? record.archiveList : null,
            archiveIndex: index + 1
          };
          // hide the popover
          if (element != null) {
            this.$refs[element][0].$emit("close");
          }
          this.$root.$emit("playBackVideoStarted", obj);
        } else {
          this.$toastr.error("Archive is not available at this point. Please try again later.");
          if (element != null) {
            this.$refs[element][0].$emit("close");
          }
        }
      });
    },
    showPhoneVisitDetails(record) {
      this.visitTypeDetails = {
        visitType: record.visitType.toLowerCase(),
        threadId: this.participantInfo.id,
        participantId: this.participantInfo.userDefinedParticipantId,
        visitName: record.name,
        details: ""
      };
      if (record.reportedDataTrackerId && (this.visitTypeDetails.visitType === "homevisit" || this.visitTypeDetails.visitType === "phonecall")) {
        this.$api.getContactDetailsFact(record.reportedDataTrackerId, this.participantInfo.id).then(response => {
          if (response.body) {
            this.visitTypeDetails.details = response.body;
            const checkCountryCodeplus = this.visitTypeDetails.details.countryCode.toString();
            if (checkCountryCodeplus.includes("+") === false) {
              this.visitTypeDetails.details.countryCode = `+${this.visitTypeDetails.details.countryCode}`;
            }
            this.$refs.HomePhonecallDataViewModal.show();
          }
        });
      }
    },
    closeScreen() {
      this.$refs.HomePhonecallDataViewModal.hide();
    },
    editVisit() {
      this.$refs.HomePhonecallDataViewModal.hide();
      this.showScheduleVisit = true;
    },
    getConfiguredVisitData() {
      this.showScheduleVisit = false;
    },
    cancelModal() {
      this.showScheduleVisit = false;
    },
    checkViewPermissions(activity) {
      let currentRole;

      switch (this.userAccess[0][0]) {
        case "Pi":
          currentRole = "Principal-Investigator";
          break;
        case "HomeHealth":
          currentRole = "Home-Health";
          break;
        case "SubPi":
          currentRole = "Sub-Investigator";
          break;
        case "StudyCoordinator":
          currentRole = "Study-Coordinator";
          break;
        case "SiteDataLock":
          currentRole = "Site-DataLock";
          break;
        case "Rater":
          currentRole = "Rater";
          break;
        case "Cra":
          currentRole = "CRA";
          break;
        case "CraUB":
          currentRole = "CraUB";
          break;
        case "Dm":
          currentRole = "Data-Management";
          break;
        case "CallCenter":
          currentRole = "Call-Center";
          break;
        case "Quality":
          currentRole = "Quality";
          break;
        case "Biostatistics":
          currentRole = "Biostatistics";
          break;
        case "Interviewer":
          currentRole = "Interviewer";
          break;
        case "HomeHealthCoordinator":
          currentRole = "HomeHealthCoordinator";
          break;
        case "Pharmacovigilance":
          currentRole = "Pharmacovigilance";
          break;
        case "Support":
          currentRole = "Support";
          break;
      }

      let canView;
      // if these are Admin roles
      if (this.user && (this.user.userRole == "StudyAdmin" || this.user.userRole == "SystemAdmin" || this.user.userRole === "StudyManager" || this.user.userRole === "Support")) {
        canView = true;
      } else {
        if (this.user && (this.user.userRole == "Interviewer" || this.user.userRole == "HomeHealthCoordinator")) {
          canView = false;
        } else if (activity.viewPermissions && activity.viewPermissions.length) {
          const permissionsArr = activity.viewPermissions.split(",");
          canView = permissionsArr.some(user => user == currentRole);
        } else {
          canView = true;
        }
      }
      return canView;
    },

    showVisitAddress(details) {
      let formString = "";
      if (details.address != "") {
        formString = details.address;
      }
      if (details.city != "") {
        formString = formString + ", " + details.city;
      }
      if (details.state != "") {
        formString = formString + ", " + details.state;
      }
      if (details.country != "") {
        formString = formString + ", " + details.country;
      }
      if (details.zipcode != "") {
        formString = formString + ", " + details.zipcode;
      }
      return formString;
    },
    getStudyFeatures() {
      const toggleFeatures = this.$store.getters.getStudyToggledFeatures ? this.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
      toggleFeatures.forEach(feature => {
        if (feature.featureKey === "DISPLAY_PHQ9_SCORE") {
          this.showTotalScore = feature.enabled;
        }
      });
    },
    onDemandModalshow(record) {
      this.copyRecord = record;
      if (this.copyRecord.status === "Scheduled" || this.copyRecord.status === "Cancelled") {
        this.getDeletedRecordOfOnDemond();
        this.$refs["cancleOnDemondModal"].show();
      }
    },
    onDemandModalHide() {
      this.$root.$emit("bv::hide::modal", "onDemandActivity", "#btnOnDemand");
    },
    getDeletedRecordOfOnDemond() {
      this.onDemandActivityDetails = [];
      this.$api.getDeleteOnDemondActivityFact(this.$route.params.studyId, this.copyRecord.studyVersionId, this.copyRecord.taskInstanceId, this.$route.params.participantId).then(
        response => {
          this.onDemandActivityDetails.push(response.body);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting record.");
        }
      );
    },
    cancleOnDemoanActivity() {
      this.$refs["cancleOnDemondModal"].hide();
      this.$refs["addCancleReason"].show();
    },
    deleteOnDemondActivity() {
      const userObj = localStorageService.getItem("userObj");
      const data = {
        id: this.copyRecord.id,
        participantId: this.copyRecord.participantId,
        studyId: this.copyRecord.studyId,
        studyVersionId: this.copyRecord.studyVersionId,
        taskId: this.copyRecord.taskId,
        taskInstanceId: this.copyRecord.taskInstanceId,
        sentBy: this.copyRecord.sentBy,
        taskType: this.copyRecord.type,
        taskTitle: this.copyRecord.name,
        withdrawnReason: this.withdrawnReason,
        withdrawnBy: userObj.id,
        withdrawnDateUtc: new Date(),
        participantCurrentDay: this.copyRecord.participantCurrentDay,
        status: this.copyRecord.status,
        startDay: null,
        endDay: null,
        milestoneId: null
      };
      const that = this;
      this.$api.postDeleteOnDemondActivityFact(this.$route.params.studyId, data).then(
        () => {
          that.$emit("refreshParticipantTaskList");
          that.withdrawnReason = "";
          toastr.success("Activity canceled successfully.");
          that.$refs["addCancleReason"].hide();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting record.");
        }
      );
    },
    cancleActivityModal() {
      this.$refs["addCancleReason"].hide();
    },
    checkEdroActivity(activityName) {
      let checkEdro = true;
      switch (activityName) {
        case "contrast acuity exam":
          checkEdro = false;
          break;
        case "skin health activity":
          checkEdro = false;
          break;
        case "ihealth track bpm":
          checkEdro = false;
          break;
        case "visual acuity exam":
          checkEdro = false;
          break;
        case "forced spirometry":
          checkEdro = false;
          break;
        case "pef maneuver":
          checkEdro = false;
          break;
      }
      return checkEdro;
    }
  },
  mounted() {
    this.$root.$on("playBackVideoEnded", () => {
      this.mainActiveArchiveId = null;
      this.activeArchiveId = null;
      this.$root.recordingPage = { pageName: null };
    });
    this.$root.$on("switchVideo", archive => {
      this.activeArchiveId = archive.id;
    });
    this.getStudyFeatures();
  }
};
</script>

<style lang="scss" src="@/assets/table-styling.scss"></style>
<style lang="scss">
.my-modal {
  width: 1036px !important;
}
.cancle-activity-title {
  margin: -57px 0px 0px 408px;
  font-family: Roboto-Regular;
  font-size: 20px;
  font-weight: bold;
  color: #000;
}
.activity-cancel-btn {
  width: 93px;
  height: 36px;
  align-items: center;
  gap: 10px;
  margin: 19px 0px 20px 465px;
  padding: 1px 25px;
  border-radius: 2px;
  border: solid 1px #dbe2ed;
  background-color: #fff !important;
  font-family: Roboto-Regular;
  font-size: 14px;
  text-align: center;
  color: #4c8ce4 !important;
}
.heading-title {
  margin: 0 137px 20px 0;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  color: #000;
  background: #edeced;
}
@media (min-width: 768px) {
  .modal-xl {
    width: 90%;
    max-width: 1050px;
  }
}
.modal-header {
  border-bottom: none !important;
}
.table td {
  border-top: none !important;
}
.cancle-activity-name {
  margin: -52px 0px 5px 155px;
  font-family: Roboto-Regular;
  font-size: 20px;
  font-weight: 600;
  color: #000;
}
.text-message {
  margin: 3px 25px 29px 25px;
  font-family: Roboto-Regular;
  font-size: 14px;
  line-height: normal;
  text-align: center;
  color: #666669;
}
.reason-label {
  margin: 0px 0px 17px 19px;
  font-family: Roboto-Regular;
  font-size: 14px;
  text-align: left;
  color: #666669;
}
.optional {
  font-family: Roboto-Regular;
  font-size: 14px;
  text-align: left;
  color: #888;
}
.withdrawn-reason {
  width: 427px;
  height: 36px;
  margin: 0px 3px 35px 18px;
  // padding: 7px 72px 12px 143px;
  border: solid 1px #c5d0d5;
}
.btn-no {
  width: 100px;
  height: 38px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 24px 25px 122px;
  border-radius: 4px;
  background-color: #e0e0e0;
}
.btn-yes {
  width: 100px;
  height: 38px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 0 24px 0 0;
  border-radius: 4px;
  background-color: #4c8ce4;
}
.quick-view-icon {
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.ondemand-activity-icon {
  background-color: #4c8ce4;
  padding: 0px 2px 1px 3px;
  border-radius: 2px;
  img {
    width: 15px;
    height: 15px;
  }
}
.optional-activity-icon {
  padding: 0px 2px 1px 0px;
  img {
    width: 15px;
    height: 15px;
  }
}
.participant-task-table {
  padding: 0px 20px 0px !important;
  margin-bottom: 20px;
  overflow-x: auto;
  background-color: #fff;
  .table-title {
    font-size: 15px;
  }
  .text-info {
    color: #1e8fe1 !important;
    cursor: pointer;
    font-weight: 600;
    &.text-info-cursor {
      cursor: context-menu;
    }
    &.removed-text-info {
      color: #b0bac9 !important;
      cursor: pointer;
      font-weight: 600;
    }
  }
  .text-info:hover {
    text-decoration: none;
  }
  .due-date-indicator {
    display: inline-block;
    color: #4a4a4a;
    opacity: 0.5;
    border: solid 2px #e4e8eb;
    background-color: #f7f7f7;
    padding: 0px 5px;
    height: 27px;
    width: 100px;
    border-radius: 5px;
  }
  .toggle-text {
    background-color: #fff;
    border-right: 1px solid #e4e8eb;
    border-left: 1px solid #e4e8eb;
    border-bottom: 1px solid #e4e8eb;
    border-top: none;
    span {
      background-image: url(/static/img/arrow-down-blue.png) !important;
      height: 20px;
      display: inline-block;
      background-repeat: no-repeat;
      width: 20px;
      background-position-y: 1px;
      background-position-x: 1px;
    }
    .collapsed {
      vertical-align: top;
      transform: rotate(180deg);
      background-position-y: -1px;
      background-position-x: -1px;
    }
  }
  .color-text {
    color: #a8a8a8;
  }
  .card {
    .card-body {
      margin-top: -1px;
      border-right: 1px solid #e4e8eb;
      border-left: 1px solid #e4e8eb;
      border-bottom: 1px solid #e4e8eb;
      .divTable {
        width: 100%;
      }
    }
  }
  .clock {
    margin-top: -3px;
  }
  .of {
    margin-right: -1px;
    margin-left: 2px;
  }
  .ttlPge {
    margin-left: -7px;
  }
  .title-icons-container {
    .skipped-task {
      margin-left: 5px;
      img {
        width: auto;
        height: 15px;
      }
    }
  }
}
.telehealth-call {
  .participant-task-table {
    .toggle-text {
      font-size: 12px;
    }
    .due-date-indicator {
      height: 22px;
      width: 75px;
    }
    .table-title {
      font-size: 12px;
    }
  }
}
.close-icon {
  cursor: pointer;
  float: right;
  position: relative;
  left: 17px;
}
.subHeading {
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}
.rowDiv {
  background-color: #eaf0f4;
}
.evaluateModalPhnoField {
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
}
.evaluateAddressField {
  color: #4a4a4a;
  font-weight: bold;
}
.cancelText {
  color: #666669;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.activityNameLayout {
  position: relative;
  top: 0.8rem;
}
.visitTypeIcon {
  width: 18px;
  height: 20px;
  cursor: pointer;
  margin-bottom: 0.2rem;
}
.visitNameTextDisplay {
  position: relative;
  top: 0.5rem;
  color: #666669;
}
.blinded-site {
  pointer-events: none !important;
}
.font-bolder > i {
  font-size: 14px;
  font-weight: 500;
  font-family: "Roboto-Regular";
}
.no-task {
  min-width: 1325.8px !important;
}
.divTableHead b {
  font-size: 12px;
  color: #9b9b9b;
}
.status-align {
  white-space: nowrap;
}
.show_all_div {
  max-width: 1840px;
  width: 129.65%;
}
.view_all_task .show_all_div {
  max-width: 1840px;
  width: 130.6%;
}
.hide {
  display: none;
}
.title-icons-container {
  display: inline-table;
  vertical-align: middle;
}
@media screen and (min-width: 1280px) {
  .show_all_div {
    width: 151%;
  }
  .participant-task-table .toggle-text {
    border-right: none;
  }
}

@media screen and (min-width: 1400px) {
  .show_all_div {
    width: 123.2%;
  }
  .participant-task-table .toggle-text {
    border-right: none;
  }
}
@media screen and (min-width: 1600px) {
  .show_all_div {
    width: 114.6%;
  }
}
@media screen and (min-width: 1900px) {
  .show_all_div {
    width: 115.65%;
    max-width: 1680px;
  }
}
.margin-for-cancle-btn {
  margin-top: -8px !important;
}
</style>
